
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"46","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"45","height":"31","rx":"5.5","fill":"#fff","stroke":"#EEE"}}),_c('g',{attrs:{"clip-path":"url(#clip0_100_5553)","stroke":"#333","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M28.257 12.667H17.743c-.726 0-1.314.597-1.314 1.333v6.667c0 .736.588 1.333 1.314 1.333h10.514c.726 0 1.315-.597 1.315-1.333V14c0-.736-.589-1.333-1.315-1.333z"}}),_c('path',{attrs:{"d":"M25.629 22V11.333c0-.353-.139-.692-.385-.943-.247-.25-.581-.39-.93-.39h-2.628c-.349 0-.683.14-.93.39-.246.25-.384.59-.384.943V22"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_100_5553"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(15.114 8)","d":"M0 0h15.771v16H0z"}})])])])
          )
        }
      }
    